module.exports = __webpack_public_path__ + "static/media/14@720w.cae00a22.jpg";